import { UilFilm } from "@iconscout/react-unicons";
import Status from "components/Status";
import Table from "../../Overview/components/OverviewTable/Table";
import { ActionMenu } from "./StatusActions";
import useSWR from "swr";
import Spinner from "components/Spinner";

export default function Movies() {
  const { data: moviesData, isValidating } = useSWR(`/entertainment/movie-box/medias?page-size=25&page=1&search-query=&status=`)
  const movies = moviesData?.data?.data
  const hasMovies = movies?.length > 0;

  if(isValidating) return <Spinner />
  if (!hasMovies) {
    return (
      <div className="flex flex-1 flex-col justify-center items-center text-center mt-10">
        <UilFilm className="text-gray-300" size={64} />
        <h2 className="text-lg font-medium text-gray-600 mt-4">
          No movie added yet
        </h2>
      </div>
    );
  }

  const columns = [
    {
      title: "Title",
      field: "title",
      sorting: false,

      render: (rowData) => (
        <div className="flex items-center gap-3 ">
          <img
            src={rowData?.poster}
            alt={rowData.title}
            className="w-10 h-10 rounded object-cover"
          />
          {/* <Tooltip title={rowData.title} placement="top-end"> */}

          <p className="font-medium text-gray-700 text-nowrap ">{rowData?.title}</p>
          {/* </Tooltip> */}
        </div>
      ),
    },
    { title: "Type", field: "type", sorting: false },
    { title: "Release", field: "release_year", sorting: false },
    { title: "Category", field: "category", sorting: false, render: (data) => data?.genres?.join(", ") },
    { title: "Language", field: "language", sorting: false },
    { title: "Country", field: "country", sorting: false },
    {
      title: "Status",
      field: "status",
      sorting: false,
      render: (rowData) => {
        const statusStyles = {
          live: { color: "#219653", bg: "rgba(33, 150, 83, 0.1)" },
          pending: { color: "#A15E1E", bg: "rgba(161, 94, 30, 0.1)" },
          unpublished: { color: "#828282", bg: "rgba(130, 130, 130, 0.1)" },
          draft: { color: "#828282", bg: "rgba(130, 130, 130, 0.1)" },
          archived: { color: "#000", bg: "rgba(0, 0, 0, 0.05)" },
        };

        const { color, bg } = statusStyles[rowData.status] || {
          color: "#000",
          bg: "rgba(0,0,0,0.05)",
        };

        return <Status text={rowData.status} color={color} bg={bg} />;
      },
    },
    {
      title: "Action",
      field: "actions",
      sorting: false,
      render: (rowData) => <ActionMenu data={rowData} />,
    },
  ];

  return (
    <div className="mt-6">
      <Table columns={columns} data={movies} />
    </div>
  );
}
